module.exports = __webpack_public_path__ + "img/Picture30.f9a6061b.png";